// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
    padding: 26px !important;
}

.modal-footer,
.modal-header {
    border: none !important;
}

.modal-header .modal-title {
    width: 95% !important;
    margin: auto !important;
    justify-content: center !important;
    align-items: center !important;
    display: flex !important;
    color: var(--light-black);
    text-align: center;
    font-family: var(--Inter-Bold700);
    font-size: 18px;
    line-height: 28px;
    letter-spacing: -0.36px;
}

.modal-footer {
    justify-content: center !important;
}

.modal-footer button {
    border-radius: 7px !important;
    background: var(--field-background) !important;
    padding: 12px 52px !important;
    color: var(--light-black);
    text-align: center;
    font-family: var(--Inter-Bold700);
    font-size: 16px;
    text-transform: uppercase;
    border: none !important;
    width: 255px;
}

.modal-footer button:hover {
    background: var(--light_grey) !important;
    color: var(--light-black) !important;
}


.dropDown-box {
    width: 100%;
    height: 50px;
}

.dropDown-box button:nth-child(1) {
    width: 80% !important;
    background-color: var(--white) !important;
    border-top-left-radius: 16px !important;
    border-bottom-left-radius: 16px;
    border: 1px solid var(--light_grey) !important;
    color: var(--placeholder-grey) !important;
}

.dropDown-box button:nth-child(2) {
    background-color: var(--white) !important;
    border: 1px solid var(--light_grey) !important;
    color: #000 !important;
}

.dropdown-menu.show {
    width: 100% !important;
}

.modal-input-style {
    margin-bottom: 10px !important;
}

.modal-input-style .form-control {
    background-color: var(--field-background) !important;
    border: none !important;
    height: 50px !important;
    padding: 10px 20px !important;
    font-family: var(--Inter-SemiBold600);
    font-size: 16px !important;
    color: var(--table-text-color) !important;
}

.form-control:disabled {
    opacity: 0.7 !important;
}

.modal-input-style .form-control::placeholder {
    font-family: var(--inter-Regular);
    color: var(--placeholder-grey);
}

.item-wrapper .overlap-3 .span-wrapper {
    outline: none;
    background-color: transparent;
}


@media (min-width: 992px) {
    .modal-lg {
        max-width: 1150px !important;
    }
}

@media(max-width:768px) {
    .modal-content {
        padding: 15px !important;
    }

    .modal-input-style .form-control::placeholder,
    .modal-input-style .form-control {
        font-size: 16px !important;
    }
}

@media(max-width:480px) {
    .modal-content {
        padding: 0px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/BaseModal.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,kCAAkC;IAClC,8BAA8B;IAC9B,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;IAC7B,8CAA8C;IAC9C,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;AACxC;;;AAGA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,uCAAuC;IACvC,+BAA+B;IAC/B,8CAA8C;IAC9C,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;IACzC,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oDAAoD;IACpD,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,qCAAqC;IACrC,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;;AAGA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".modal-content {\n    padding: 26px !important;\n}\n\n.modal-footer,\n.modal-header {\n    border: none !important;\n}\n\n.modal-header .modal-title {\n    width: 95% !important;\n    margin: auto !important;\n    justify-content: center !important;\n    align-items: center !important;\n    display: flex !important;\n    color: var(--light-black);\n    text-align: center;\n    font-family: var(--Inter-Bold700);\n    font-size: 18px;\n    line-height: 28px;\n    letter-spacing: -0.36px;\n}\n\n.modal-footer {\n    justify-content: center !important;\n}\n\n.modal-footer button {\n    border-radius: 7px !important;\n    background: var(--field-background) !important;\n    padding: 12px 52px !important;\n    color: var(--light-black);\n    text-align: center;\n    font-family: var(--Inter-Bold700);\n    font-size: 16px;\n    text-transform: uppercase;\n    border: none !important;\n    width: 255px;\n}\n\n.modal-footer button:hover {\n    background: var(--light_grey) !important;\n    color: var(--light-black) !important;\n}\n\n\n.dropDown-box {\n    width: 100%;\n    height: 50px;\n}\n\n.dropDown-box button:nth-child(1) {\n    width: 80% !important;\n    background-color: var(--white) !important;\n    border-top-left-radius: 16px !important;\n    border-bottom-left-radius: 16px;\n    border: 1px solid var(--light_grey) !important;\n    color: var(--placeholder-grey) !important;\n}\n\n.dropDown-box button:nth-child(2) {\n    background-color: var(--white) !important;\n    border: 1px solid var(--light_grey) !important;\n    color: #000 !important;\n}\n\n.dropdown-menu.show {\n    width: 100% !important;\n}\n\n.modal-input-style {\n    margin-bottom: 10px !important;\n}\n\n.modal-input-style .form-control {\n    background-color: var(--field-background) !important;\n    border: none !important;\n    height: 50px !important;\n    padding: 10px 20px !important;\n    font-family: var(--Inter-SemiBold600);\n    font-size: 16px !important;\n    color: var(--table-text-color) !important;\n}\n\n.form-control:disabled {\n    opacity: 0.7 !important;\n}\n\n.modal-input-style .form-control::placeholder {\n    font-family: var(--inter-Regular);\n    color: var(--placeholder-grey);\n}\n\n.item-wrapper .overlap-3 .span-wrapper {\n    outline: none;\n    background-color: transparent;\n}\n\n\n@media (min-width: 992px) {\n    .modal-lg {\n        max-width: 1150px !important;\n    }\n}\n\n@media(max-width:768px) {\n    .modal-content {\n        padding: 15px !important;\n    }\n\n    .modal-input-style .form-control::placeholder,\n    .modal-input-style .form-control {\n        font-size: 16px !important;\n    }\n}\n\n@media(max-width:480px) {\n    .modal-content {\n        padding: 0px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
